<df-shared-lib-image-upload-cropper
  [isDialog]="true"
  [roundCropper]="data.mode.includes('LOGO') ? true : false"
  [croppedImageRatio]="
    data.ratio ? data.ratio : data.mode.includes('TITLE') ? 2 / 1 : 1
  "
  (uploadFormData)="upload($event)"
></df-shared-lib-image-upload-cropper>
